/**
 * BrandBadge — compact inline display of the selected brand (small logo + name).
 * Used in campaign creation and publisher config read-only views.
 */
import React from 'react';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useS3BlobUrl } from 'src/hooks/useS3BlobUrl';

interface BrandBadgeProps {
  brandType: string;
  businessName: string;
  logoS3Key: string;
  mediaBucketName: string;
}

export const BrandBadge: React.FC<BrandBadgeProps> = ({ brandType, businessName, logoS3Key, mediaBucketName }) => {
  const logoUrl = useS3BlobUrl(mediaBucketName, logoS3Key, { contentType: 'image/png' });

  return (
    <Row alignmentVertical="center" data-testid={`brand-badge-${brandType}`} spacing="200">
      {logoUrl
        ? <img alt={`${businessName} logo`} src={logoUrl} style={{ width: 32, height: 32, objectFit: 'contain' }} />
        : <div style={{ width: 32, height: 32, backgroundColor: '#f5f5f5', borderRadius: 4 }} />
      }
      <Text type="b300">{businessName}</Text>
    </Row>
  );
};
